import axios from '@/http/index';

const base = '';
// （服务开单或修改订单）获得已经设置的统称项目信息
export const getItemTypeAndItemList = (params) => axios.get(`${base}/erp/customerOrder/getItemTypeAndItemList`, params).then((res) => res.data);
// 获得会员卡相关信息
export const getMemberCardMsg = (params) => axios.get(`${base}/erp/member/getMemberCardMsg`, params).then((res) => res.data);
// (服务开单)获得赠送的卡券信息
export const getCardReceiveBuy = (params) => axios.get(`${base}/erp/customerOrder/getCardReceiveBuy`, params).then((res) => res.data);
// （服务开单或修改订单）根据项目id获得统称列表
export const getTechnicianListByItemId = (params) => axios.get(`${base}/erp/customerOrder/getTechnicianListByItemId`, params).then((res) => res.data);
// 获得产品列表
export const getProductList = (params) => axios.get(`${base}/erp/customerOrder/getProductList`, params).then((res) => res.data);
// 获得产品分类信息
export const getProductType = (params) => axios.get(`${base}/erp/customerOrder/getProductType`, params).then((res) => res.data);
// （服务开单或修改订单）根据产品id获得统称列表
export const getTechnicianListByProductId = (params) => axios.get(`${base}/erp/customerOrder/getTechnicianListByProductId`, params).then((res) => res.data);

// (修改订单)获得服务开单修改需要的数据
export const getOrderDetails4Update = (params) => axios.get(`${base}/erp/customerOrder/getOrderDetails4Update`, params).then((res) => res.data);
// (修改订单)删除服务项目
export const deleteItemById = (params) => axios.get(`${base}/erp/customerOrder/deleteItemById`, params).then((res) => res.data);
// (修改订单)删除产品
export const deleteProductById = (params) => axios.get(`${base}/erp/customerOrder/deleteProductById`, params).then((res) => res.data);
// （服务开单或修改订单）获得已经设置的统称项目item信息
export const getItemListPage = (params) => axios.get(`${base}/erp/customerOrder/getItemListPage`, params).then((res) => res.data);
// （服务开单）获得跳转优惠券地址
export const getCouponsSetUrl = (params) => axios.get(`${base}/erp/customerOrder/getCouponsSetUrl`, params).then((res) => res.data);
// 获得预约开单需要的信息
export const getBilling4Book = (params) => axios.get(`${base}/erp/bookOrder/getBilling4Book`, params).then((res) => res.data);

// 查询会员套餐订单记录
export const getBeautyPackageList = (params) => axios.get(`${base}/erp/lookVipCard/getServeBeautyPackageList`, params).then((res) => res.data);
// 获得新增会员跳转链接
export const getMemberUrl = (params) => axios.get(`${base}/erp/member/getMemberUrl`, params).then((res) => res.data);

// (3.8.0)根据关键字查询服务项目，产品，套餐信息
export const getOrderItemList = (params) => axios.get(`${base}/erp/customerOrder/getOrderItemList`, params).then((res) => res.data);
// 根据会员套餐ID获得提成信息
export const getIdSelectCard = (params) => axios.get(`${base}/erp/lookVipCard/selectVipCardPercentage`, params).then((res) => res.data);
// 获取会员套餐开单员列表
export const getStaffIdList = (params) => axios.get(`${base}/erp/lookVipCard/technicianList`, params).then((res) => res.data);
// （3.8.0）获得顾客样子卡信息
export const getUnionUserMsg = (params) => axios.get(`${base}/api/union/getUnionUserMsg`, params).then((res) => res.data);
// （3.8.0服务开单或修改订单）新增或修改服务开单数据
export const saveOrUpdate = (params) => axios.post(`${base}/erp/customerOrder/saveOrUpdateServerOrder`, params).then((res) => res.data);
// (3.8.0)获得店铺结算设置信息
export const getPayCodeList = (params) => axios.get(`${base}/erp/payInfo/getPayTypeSetList`, params).then((res) => res.data);

// （4.5.0）获取全局提成设置
export const getPercentageSkin = (params) => axios.get(`${base}/busmanage/lookStoreMain/getPercentageSkin`, params).then((res) => res.data);
// （5.1.0）服务开单中，点击服务项目的选择销售，出现的员工列表（选择销售）
export const getTechnicianListBySellItemId = (params) => axios.get(`${base}/erp/customerOrder/getTechnicianListBySellItemId`, params).then((res) => res.data);

// (4.7.0)获得顾客信息列表
export const getCustomerMsgList = (params) => axios.get(`${base}/erp/customer/getCustomerMsgList`, params).then((res) => res.data);

// (5.3.0)关联顾客电话，查询预约列表接口
export const getRoomRelationDetails = (params) => axios.get(`${base}/erp/lookBookRoom/getRoomRelationDetails`, params).then((res) => res.data);

// (5.3.0)选择房间列表
export const getRoomInfo = (params) => axios.get(`${base}/erp/lookBookRoom/getRoomInfo`, params).then((res) => res.data);
// 获得一个顾客信息详情
export const getOneCustomerMsg = (params) => axios.get(`${base}/erp/customer/getOneCustomerMsg`, params).then((res) => res.data);

// 5.7erp选择统称，选择销售的轮牌列表
export const erpTechnicianCardByMainId = (params) => axios.get(`${base}/erp/lookTechnicianCard/erpTechnicianCardByMainId`, params).then((res) => res.data);

// 5.7（服务开单或修改订单）根据项目、产品、套餐id获取统称-员工列表
export const getStaffBrandList = (params) => axios.get(`${base}/erp/lookTechnicianCard/getTechnicianListByItemId`, params).then((res) => res.data);

// 5.10 服务开单-选择房间
export const getChooseRoomInfo = (params) => axios.post(`${base}/erp/lookBookRoom/chooseRoomInfo`, params).then((res) => res.data);

// （6.2）获取会员可划扣列表
export const getCanDeductList = (params) => axios.get(`${base}/erp/customerOrder/getCanDeductList`, params).then((res) => res.data);

// (4.1)获得订单列表数量
export const getAllOrderCount = (param) => axios.get(`${base}/erp/customerOrder/getAllOrderCount`, param).then((res) => res.data);

// (6.3)电子票核销
export const checkElectronicTicket = (param) => axios.get(`${base}/erp/customerOrder/checkElectronicTicket`, param).then((res) => res.data);

// （6.5）根据轮牌列表查询员工列表
export const getByTechnicianListByCardId = (param) => axios.get(`${base}/erp/lookTechnicianCard/getByTechnicianListByCardId`, param).then((res) => res.data);
